import { createRegionalSuburbArticles } from './councilArticleTemplate';

const lv = {
  council: 'Lockyer Valley Regional Council',
  planningScheme: 'Lockyer Valley Planning Scheme',
  planningUrl: 'https://www.lockyervalley.qld.gov.au/planning-and-building/planning-scheme',
  region: 'the Lockyer Valley',
};

export const gattonArticles = createRegionalSuburbArticles('Gatton', 'gatton', {
  ...lv,
  distance: '90km west of Brisbane, in the Lockyer Valley',
  keyInfra: 'Gatton is the Lockyer Valley\'s principal town and a major agricultural centre. The University of Queensland Gatton Campus is a significant educational anchor. The Warrego Highway provides direct road connectivity to Brisbane and Toowoomba. Gatton has established retail, medical, and community services. The Lockyer Valley is known as "Australia\'s salad bowl" for its productive farmland.',
  zones: [
    { name: 'Township Centre (Gatton)', product: 'Mixed-use, retail + residential' },
    { name: 'Low-Medium Density Residential', product: 'Townhouses, duplexes' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural', product: 'Agricultural, farmland' },
  ],
  mainStreets: 'Railway Street, Spencer Street, William Street, and Warrego Highway',
  priceRange: [
    { type: 'Standard house lot', range: '$300K - $480K' },
    { type: 'Larger residential', range: '$400K - $700K' },
    { type: 'Rural / farmland', range: '$500K - $2.0M+' },
  ],
  keyDriver: 'UQ Gatton Campus educational anchor, Lockyer Valley agricultural economy, Warrego Highway Brisbane connectivity, and affordable housing attracting commuters',
  uniqueFactor: 'Gatton is the Lockyer Valley\'s major town, anchored by the University of Queensland\'s Gatton Campus. The town\'s agricultural heritage, established services, and improving Warrego Highway connectivity make it an increasingly viable commuter option for Brisbane workers seeking affordable rural lifestyle. Student and staff housing demand from UQ provides an institutional anchor.',
  comparison: 'Gatton offers the Lockyer Valley\'s strongest township infrastructure with the added value of UQ\'s institutional anchor. Pricing is extremely affordable compared to Brisbane or Ipswich.',
  nearbyAmenity: 'UQ Gatton Campus, Gatton town centre, Warrego Highway, Lockyer Valley farmland',
});

export const laidleyArticles = createRegionalSuburbArticles('Laidley', 'laidley', {
  ...lv,
  distance: '80km west of Brisbane, in the Lockyer Valley',
  keyInfra: 'Laidley is a historic Lockyer Valley town with a charming heritage main street. Laidley sits in the heart of the Valley\'s productive agricultural land. The Warrego Highway provides road connectivity. The town hosts popular seasonal events and markets. Established retail, medical, and community services are available.',
  zones: [
    { name: 'Township Centre (Laidley)', product: 'Township retail + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage, lifestyle' },
    { name: 'Rural', product: 'Agricultural, farmland' },
  ],
  mainStreets: 'Patrick Street, William Street, Drayton Street, and Warrego Highway',
  priceRange: [
    { type: 'Standard house lot', range: '$280K - $430K' },
    { type: 'Acreage / lifestyle', range: '$400K - $800K' },
    { type: 'Rural / farmland', range: '$500K - $1.5M+' },
  ],
  keyDriver: 'Heritage township character, productive agricultural land, Warrego Highway access, and SEQ\'s most affordable residential property',
  uniqueFactor: 'Laidley offers some of the most affordable residential property in South East Queensland with a genuine country town character. The heritage main street, agricultural setting, and improving road access to Brisbane are attracting tree-changers and retirees seeking quiet, affordable living.',
  comparison: 'Laidley offers SEQ\'s most affordable country town living with heritage character. The value proposition attracts buyers from across the region.',
  nearbyAmenity: 'Laidley main street, Lockyer Valley farmland, Warrego Highway, community events and markets',
});

export const plainlandArticles = createRegionalSuburbArticles('Plainland', 'plainland', {
  ...lv,
  distance: '75km west of Brisbane, at the gateway to the Lockyer Valley',
  keyInfra: 'Plainland is positioned at the intersection of the Warrego Highway and Laidley-Plainland Road, making it the gateway to the Lockyer Valley from Brisbane. Plainland Crossing shopping centre provides modern retail. The Warrego Highway provides direct road connectivity. New residential estates are being developed.',
  zones: [
    { name: 'Centre (Plainland Crossing)', product: 'Mixed-use, retail + residential' },
    { name: 'Low-Medium Density Residential', product: 'Townhouses, duplexes' },
    { name: 'Low Density Residential', product: 'Houses, new estates' },
    { name: 'Emerging Community', product: 'New residential development' },
  ],
  mainStreets: 'Warrego Highway, Laidley-Plainland Road, and commercial precinct roads',
  priceRange: [
    { type: 'Standard house lot', range: '$330K - $500K' },
    { type: 'New estate lot', range: '$350K - $550K' },
    { type: 'Larger lot / acreage', range: '$500K - $900K' },
  ],
  keyDriver: 'Gateway positioning on the Warrego Highway, Plainland Crossing retail, new residential estate development, and affordable housing for Brisbane commuters',
  uniqueFactor: 'Plainland is the Lockyer Valley\'s growth node — positioned at the highway junction that serves as the gateway from Brisbane. The modern Plainland Crossing shopping centre and new residential estates signal transition from rural to suburban character. Affordable pricing and improving Brisbane commute times attract first home buyers and young families.',
  comparison: 'Plainland is the Lockyer Valley\'s most accessible growth area. Modern retail and new estates distinguish it from traditional valley towns.',
  nearbyAmenity: 'Plainland Crossing shopping, Warrego Highway, new residential estates',
});

export const withcottArticles = createRegionalSuburbArticles('Withcott', 'withcott', {
  ...lv,
  distance: '95km west of Brisbane, at the base of the Toowoomba Range',
  keyInfra: 'Withcott is positioned at the base of the Toowoomba Range, making it the gateway between the Lockyer Valley and Toowoomba. The Second Range Crossing (new highway) dramatically improved connectivity. Withcott has a small commercial centre with local services. Bushland and range scenery provide natural amenity.',
  zones: [
    { name: 'Township (Withcott)', product: 'Local retail + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage, range-fringe lifestyle' },
    { name: 'Rural', product: 'Agricultural, grazing' },
  ],
  mainStreets: 'Old Toowoomba Road, Toll Bar Road, and Range access roads',
  priceRange: [
    { type: 'Standard house lot', range: '$300K - $470K' },
    { type: 'Acreage / range fringe', range: '$450K - $850K' },
    { type: 'Rural property', range: '$500K - $1.2M+' },
  ],
  keyDriver: 'Second Range Crossing dramatically improved connectivity, gateway positioning between Lockyer Valley and Toowoomba, range scenery, and affordable lifestyle',
  uniqueFactor: 'Withcott has been transformed by the Second Range Crossing highway, which passes through the area. The improved connectivity between the Lockyer Valley and Toowoomba has lifted property values and increased residential interest. The range-fringe setting provides scenic lifestyle amenity.',
  comparison: 'Withcott\'s value proposition improved dramatically with the Second Range Crossing. The gateway positioning and range scenery create lifestyle appeal at affordable pricing.',
  nearbyAmenity: 'Second Range Crossing highway, range scenery, Withcott village, Toowoomba access (nearby)',
});

export const forestHillArticles = createRegionalSuburbArticles('Forest Hill', 'forest-hill', {
  ...lv,
  distance: '85km west of Brisbane, in the Lockyer Valley',
  keyInfra: 'Forest Hill is a small Lockyer Valley township positioned on the Warrego Highway between Gatton and Laidley. The town has a local school, general store, and community facilities. The surrounding farmland is among Queensland\'s most productive. Forest Hill offers a quiet, rural lifestyle.',
  zones: [
    { name: 'Township (Forest Hill)', product: 'Local services + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage' },
    { name: 'Rural', product: 'Productive farmland' },
  ],
  mainStreets: 'Warrego Highway, William Street, and local township roads',
  priceRange: [
    { type: 'Standard house lot', range: '$270K - $420K' },
    { type: 'Acreage property', range: '$380K - $700K' },
    { type: 'Farmland', range: '$500K - $1.5M+' },
  ],
  keyDriver: 'Ultra-affordable housing, productive agricultural setting, quiet rural lifestyle, and Warrego Highway access for commuting',
  uniqueFactor: 'Forest Hill is one of SEQ\'s most affordable residential townships, offering a genuine rural lifestyle in the heart of the Lockyer Valley\'s productive farmland. The township appeals to buyers seeking tranquility and space at minimal cost.',
  comparison: 'Forest Hill offers the Valley\'s most affordable residential entry point. Properties here represent exceptional value for lifestyle buyers.',
  nearbyAmenity: 'Forest Hill township, Lockyer Valley farmland, Warrego Highway, Gatton (nearby)',
});
